<footer class="bg-black text-white py-5" [dir]="dir">
  <div class="container">
    <!-- Newsletter Section -->
    <div class="row mb-5">
      <div class="col-12">
        <div class="bg-white p-4 rounded-3 text-black">
          <div class="row align-items-center">
            <div class="col-md-6 text-center mb-3 mb-md-0">
              <img
                src="assets/img/logo.png"
                alt="MIW Logo"
                style="width: 100px"
              />
            </div>
            <div class="col-md-6 text-center text-md-start">
              <h3 class="h3 mb-3">
                {{ "translations.stay_updated" | translate }}
              </h3>
              <!-- <p class="small mb-3">
                {{ "translations.subscribe_promo" | translate }}
              </p> -->
              <!-- <div class="input-group">
                <input
                  type="email"
                  class="form-control"
                  placeholder="{{
                    'translations.email_placeholder' | translate
                  }}"
                />
                <button class="btn btn-dark" type="button">
                  {{ "translations.subscribe_button" | translate }}
                </button>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer Links Section -->
    <div class="row gy-4">
      <!-- Our Branches -->
      <div class="col-md-3 text-center text-md-start">
        <h5 class="mb-3">{{ "translations.Terms" | translate }}</h5>
        <ul class="list-unstyled">
          <!--<li class="mb-2">
    <a
      [routerLink]="['/privacy']"
      class="text-decoration-none text-reset"
    >
      {{ "translations.return_policy" | translate }}
    </a>
  </li>-->
          <li class="mb-2">
            <a [routerLink]="['/terms']"
               class="text-decoration-none text-reset">
              {{ "translations.terms_conditions" | translate }}
            </a>
          </li>
          <li class="mb-2">
            <a [routerLink]="['/privacy']"
               class="text-decoration-none text-reset">
              {{ "translations.PrivacyPolicy" | translate }}
            </a>
          </li>
          <li class="mb-2">
            <a [routerLink]="['/shipping']"
               class="text-decoration-none text-reset">
              {{ "translations.delivery_shipping" | translate }}
            </a>
          </li>

        </ul>
      </div>

      <!-- Customer Service -->
      <div class="col-md-3 text-center text-md-start">
        <h5 class="mb-3">{{ "translations.customer_service" | translate }}</h5>
        <ul class="list-unstyled">
          <li class="mb-2">
            <a [routerLink]="['/about']"
               class="text-decoration-none text-reset">
              {{ "translations.about" | translate }}
            </a>
          </li>
          <li class="mb-2">
            <a [routerLink]="['/faq']"
               class="text-decoration-none text-reset">
              {{ "translations.faq" | translate }}
            </a>
          </li>

          <li class="mb-2">
            <a [routerLink]="['/contact-us']"
               class="text-decoration-none text-reset">
              {{ "translations.contact_us" | translate }}
            </a>
          </li>


        </ul>
      </div>

      <!-- Contact Us -->
      <div class="col-md-3 text-center text-md-start">
        <h5 class="mb-3">{{ "translations.contact_us" | translate }}</h5>
        <p class="mb-2">{{ "translations.Email" | translate }}: <a href="mailto:miw_oman@hotmail.com" style="color:white">miw_oman&#64;hotmail.com</a></p>
        <p class="mb-4">{{ "translations.Phone" | translate }}: 95955432</p>
    
        <div class="align-items-center justify-content-center justify-content-md-start gap-5 px-5">
          <a href="https://www.instagram.com/miw_oman/"
             class="text-white my-5 ml-3"
             target="_blank"
             rel="noopener">
            <fa-icon [icon]="instagram" size="lg"></fa-icon>
          </a>
          <a href="https://x.com/miw_oman"
             class="text-white my-5 ml-3"
             target="_blank"
             rel="noopener">
            <fa-icon [icon]="twitter" size="lg"></fa-icon>
          </a>
          <!-- <a
     href="http://www.facebook.com"
     class="text-white my-5"
     target="_blank"
     rel="noopener"
   >
     <fa-icon [icon]="facebook" size="lg"></fa-icon>
   </a>-->
        </div>
      </div>

      <!-- Logo -->
      <div
        class="col-md-3 d-flex justify-content-center justify-content-md-end align-items-start"
      >
        <img
          src="assets/img/whitelogo.png"
          alt="MIW Logo"
          style="width: 100px"
        />
      </div>
    </div>
  </div>
</footer>
<div class="bg-black text-white-50 text-center py-3">
  <small>
    MIW © 2025. All rights reserved. Designed by
    <a href="https://d-pioneers.com/" target="_blank"> Digital Pioneers </a>
  </small>
</div>
